"use client";

import React, { useRef } from "react";
import { useEffect } from "react";
import { USERCENTRICS_CUSTOM_CONSENT_EVENT_NAME } from "./constants";
import { UsercentricsConsentCustomEvent } from "./types";
import { analyticsService } from "../../services/mixpanel/MixpanelAnalyticsService";
import { useLocation } from "react-router-dom";

export const UsercentricsConsentManager = () => {
  const location = useLocation();
  const currentLangRef = useRef<string | null>(null);

  const handleConsentChange = async (
    customEvent: UsercentricsConsentCustomEvent,
  ) => {
    const hasConsentedToMixpanel = customEvent.detail.Mixpanel === true;

    if (hasConsentedToMixpanel) {
      await analyticsService.load();
    }

    analyticsService.handleConsent(hasConsentedToMixpanel);
  };

  useEffect(() => {
    const langCode = location.pathname.includes("germany") ? "de" : "en";

    if (currentLangRef.current === langCode) {
      return;
    }

    const updateLanguage = () => {
      if (window.UC_UI?.updateLanguage) {
        window.UC_UI.updateLanguage(langCode);
        currentLangRef.current = langCode;
      }
    };

    if (window.UC_UI?.updateLanguage) {
      updateLanguage();
      return;
    }

    const onInit = () => {
      updateLanguage();
    };

    window.addEventListener("UC_UI_INITIALIZED", onInit);

    return () => {
      window.removeEventListener("UC_UI_INITIALIZED", onInit);
    };
  }, [location.pathname]);

  useEffect(() => {
    const consentListener = (e: Event) => {
      const customEvent = e as UsercentricsConsentCustomEvent;

      // onInitialPageLoad is the initial consent event before user has interacted with the consent banner
      // so we skip until user has made a choice
      if (
        customEvent.detail &&
        customEvent.detail.event === "consent_status" &&
        customEvent.detail.action !== "onInitialPageLoad"
      ) {
        void handleConsentChange(customEvent);
      }
    };

    // consent event gets triggered after the app initialized with the default- or current consent status
    // and after submitting or changing consent
    window.addEventListener(
      USERCENTRICS_CUSTOM_CONSENT_EVENT_NAME,
      consentListener,
    );

    return () => {
      window.removeEventListener(
        USERCENTRICS_CUSTOM_CONSENT_EVENT_NAME,
        consentListener,
      );
    };
  }, []);

  return (
    // The script tag is added in the index.html file as it needs to be loaded before the app initializes
    <></>
  );
};
